module.exports = __webpack_public_path__ + "img/glasses-selection-banner.950dc7e.png?v=1748838302945";